import { render, staticRenderFns } from "./ChickenlegList.vue?vue&type=template&id=7d1202dc&scoped=true"
import script from "./ChickenlegList.vue?vue&type=script&lang=js"
export * from "./ChickenlegList.vue?vue&type=script&lang=js"
import style0 from "./ChickenlegList.vue?vue&type=style&index=0&id=7d1202dc&prod&lang=scss&scoped=true"
import style1 from "./ChickenlegList.vue?vue&type=style&index=1&id=7d1202dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1202dc",
  null
  
)

export default component.exports